import { FC } from 'react';

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
}

/**
 * Mini line chart inline. Mostra trend ultimi N valori dentro AthleteCard.
 * Adattato dal mockup AI Coach.
 */
export const Sparkline: FC<SparklineProps> = ({
  data,
  width = 80,
  height = 28,
  stroke = 'var(--c-error)',
  fill,
}) => {
  if (!data || data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data.map((v, i) => [
    i * step,
    height - 4 - ((v - min) / range) * (height - 8),
  ]);
  const line = points
    .map((p, i) => (i === 0 ? `M${p[0]},${p[1]}` : `L${p[0]},${p[1]}`))
    .join(' ');
  const area = `${line} L${width},${height} L0,${height} Z`;
  const last = points[points.length - 1];

  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      {fill && <path d={area} fill={fill} opacity={0.18} />}
      <path
        d={line}
        stroke={stroke}
        strokeWidth={1.6}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={last[0]} cy={last[1]} r={2.5} fill={stroke} />
    </svg>
  );
};
